import { Flex, Heading, SimpleGrid } from '@chakra-ui/react';
import StatCard from '@features/explore/StatCard';

const MarketData = () => {
  return (
    <Flex direction="column" gap={4}>
      <Heading>Market Data</Heading>
      <SimpleGrid columns={{ base: 1, md: 4 }} gap={4}>
        <StatCard label="Total notional value" value="GHS192.1k" tooltipContent="Some info" />
        <StatCard label="Total deposits" value="GHS89k" tooltipContent="Some info" />
        <StatCard label="Total traded quantity" value="3000kg" tooltipContent="Some info" />
        <StatCard label="Average hedge percentage" value="30%" tooltipContent="Some info" />
        <StatCard label="Average fill rate" value="80%" tooltipContent="Some info" />
      </SimpleGrid>
    </Flex>
  );
};

export default MarketData;
